import { useSwiperSlide } from "swiper/react";
import { audio_click } from "../lib/SoundManager";
import React, { useState, useEffect } from "react";
import { atom, useRecoilState, useSetRecoilState } from "recoil";

const refreshStatus = atom({
  key: "FiveThree",
  default: false,
});

const refreshGuideStatus = atom({
  key: "refreshGuide-5-3",
  default: {
    display: false,
    target: "",
  },
});

export { refreshGuideStatus, refreshStatus };

export default function App() {
  const [refrsh] = useRecoilState(refreshStatus);
  const setRefreshGuide = useSetRecoilState(refreshGuideStatus);
  const swiperSlide = useSwiperSlide();
  const [clickDisplay, setClickDisplay] = useState(["block","none","block","none","block"]);
  const [clickGuideDisplay, setClickGuideDisplay] = useState("block");

  const onClickBtn = (index) => {
    audio_click();

    const currentClickDisplay = [...clickDisplay];

    currentClickDisplay[index] = "none";

    setClickDisplay(currentClickDisplay);
    setClickGuideDisplay("none");
    setRefreshGuide({
      display: true,
      target: "5-3",
    });
  };

  const onRefresh = () => {
    if (document.readyState == "complete") {
      setClickDisplay(["block","none","block","none","block"]);
      setClickGuideDisplay("block");
      setRefreshGuide({
        display: false,
        target: "5-3",
      });
    }
  };

  useEffect(() => {
    onRefresh();
  }, [refrsh]);

  if (!swiperSlide.isActive) {
    return <></>;
  }
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        // backgroundImage: "url(images/04/02/guide.png)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
        }}
      >
        <img
          style={{
            position: "absolute",
            top: "83px",
            left: "113px",
          }}
          src="images/05/03/subtitle.png"
        ></img>

        <img
          src="images/05/03/question.png"
          style={{
            position: "absolute",
            top: "160px",
            left: "110px",
          }}
        />

        <img
          onClick={()=>onClickBtn(0)}
          style={{
            position: "absolute",
            top: "176px",
            left: "126px",
            display: clickDisplay[0]
          }}
          src={"images/05/03/click-item1.png"}
        ></img>

        <img
          onClick={()=>onClickBtn(1)}
          style={{
            position: "absolute",
            top: "311px",
            left: "126px",
            display: clickDisplay[1]
          }}
          src={"images/05/03/click-item2.png"}
        ></img>

        <img
          onClick={()=>onClickBtn(2)}
          style={{
            position: "absolute",
            top: "447px",
            left: "126px",
            display: clickDisplay[2]
          }}
          src={"images/05/03/click-item3.png"}
        ></img>

        <img
          onClick={()=>onClickBtn(3)}
          style={{
            position: "absolute",
            top: "583px",
            left: "126px",
            display: clickDisplay[3]
          }}
          src={"images/05/03/click-item4.png"}
        ></img>

        <img
          onClick={()=>onClickBtn(4)}
          style={{
            position: "absolute",
            top: "719px",
            left: "126px",
            display: clickDisplay[4]
          }}
          src={"images/05/03/click-item5.png"}
        ></img>

        <img
          style={{
            position: "absolute",
            top: "250px",
            left: "1155px",
            zIndex: "2",
            display: clickGuideDisplay
          }}
          src="images/05/03/click_guide.png"
        ></img>
      </div>
    </div>
  );
}
